import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTime: any;
  JSONObject: any;
};

export type ActivateWorkflowTypeResponse = {
  __typename?: 'ActivateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ApproveDraftInput = {
  draftId: Scalars['String'];
};

export type ApproveDraftResponse = {
  __typename?: 'ApproveDraftResponse';
  approvedAt: Scalars['DateTime'];
  approvedBy: Scalars['String'];
  draftId: Scalars['String'];
  status: DraftStatus;
};

export type ApproveProposalInput = {
  artifactId: Scalars['String'];
};

export type ApproveProposalResponse = {
  __typename?: 'ApproveProposalResponse';
  artifactId: Scalars['String'];
  versionNo: Scalars['Float'];
};

export type ArtifactResponse = {
  __typename?: 'ArtifactResponse';
  artifactId: Scalars['String'];
  currentVersionNo: Scalars['Float'];
  title: Scalars['String'];
};

export type ArtifactVersionHistoryResponse = {
  __typename?: 'ArtifactVersionHistoryResponse';
  artifactId: Scalars['String'];
  currentVersionNo: Scalars['Float'];
  title: Scalars['String'];
  versions: Array<ArtifactVersionResponse>;
};

export type ArtifactVersionResponse = {
  __typename?: 'ArtifactVersionResponse';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  memo?: Maybe<Scalars['String']>;
  versionNo: Scalars['Float'];
};

export type ArtifactsResponse = {
  __typename?: 'ArtifactsResponse';
  items: Array<ArtifactResponse>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  total: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ChangeDistributionStatusInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  status: DistributionStatus;
};

export type ChannelCount = {
  __typename?: 'ChannelCount';
  channelId: Scalars['String'];
  channelName: Scalars['String'];
  count: Scalars['Float'];
};

export type ChannelGraphQl = {
  __typename?: 'ChannelGraphQL';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  postFormat: ContentFormat;
  type: ChannelType;
};

export type ChannelPostPlanOutput = {
  __typename?: 'ChannelPostPlanOutput';
  channelId: Scalars['String'];
  channelRef: ChannelRefOutput;
  lastTransitionAt: Scalars['DateTime'];
  planId: Scalars['String'];
  postId?: Maybe<Scalars['String']>;
  postRenderingFailureCount: Scalars['Float'];
  requestedAt?: Maybe<Scalars['DateTime']>;
  retryCount: Scalars['Float'];
  status: Scalars['String'];
  statusDescription?: Maybe<Scalars['String']>;
  workflowTypeId: Scalars['String'];
  workflowVersion?: Maybe<Scalars['String']>;
};

export type ChannelRefOutput = {
  __typename?: 'ChannelRefOutput';
  channelId: Scalars['String'];
  formatVersion: Scalars['String'];
  name: Scalars['String'];
};

export type ChannelSummaryGraphQl = {
  __typename?: 'ChannelSummaryGraphQL';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: ChannelType;
};

export enum ChannelType {
  Blog = 'BLOG',
  Etc = 'ETC',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Kakaotalk = 'KAKAOTALK',
  Youtube = 'YOUTUBE'
}

export type CommitManualEditInput = {
  artifactId: Scalars['String'];
  content: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
};

export type CommitManualEditResponse = {
  __typename?: 'CommitManualEditResponse';
  artifactId: Scalars['String'];
  versionNo: Scalars['Float'];
};

export enum ContentFormat {
  Html = 'HTML',
  Markdown = 'MARKDOWN',
  Plain = 'PLAIN'
}

export type ContentPipelineStats = {
  __typename?: 'ContentPipelineStats';
  drafts: DraftStats;
  originalPosts: OriginalPostStats;
  posts: PostStats;
  workflow: WorkflowStats;
};

export enum ConversationStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum CrawlJobStatus {
  Failed = 'FAILED',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type CrawlJobSummary = {
  __typename?: 'CrawlJobSummary';
  crawlJobId: Scalars['String'];
  resultsCount: Scalars['Float'];
  scheduledAt?: Maybe<Scalars['DateTime']>;
  status: CrawlJobStatus;
};

export type CrawlTargetFilters = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CrawlTargetResponse = {
  __typename?: 'CrawlTargetResponse';
  crawlTargetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  recentJobs?: Maybe<Array<CrawlJobSummary>>;
  schedule: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  workflowTypeCode: Scalars['String'];
};

export type CrawlTargetsResponse = {
  __typename?: 'CrawlTargetsResponse';
  items: Array<CrawlTargetResponse>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  total: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type CreateArtifactInput = {
  content: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  originKind: OriginKind;
  originRef?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateArtifactResponse = {
  __typename?: 'CreateArtifactResponse';
  artifactId: Scalars['String'];
  versionNo: Scalars['Float'];
};

export type CreateCrawlTargetInput = {
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  schedule?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  workflowTypeCode: Scalars['String'];
};

export type CreateOriginalPostInput = {
  content: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sourceUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateOriginalPostResponse = {
  __typename?: 'CreateOriginalPostResponse';
  createdAt: Scalars['DateTime'];
  originalPostId: Scalars['String'];
  status: OriginalPostStatus;
};

export type CreatePlanInput = {
  channelId: Scalars['String'];
  draftId: Scalars['String'];
  workflowTypeId: Scalars['String'];
  workflowVersion?: InputMaybe<Scalars['String']>;
};

export type CreatePlanResponse = {
  __typename?: 'CreatePlanResponse';
  channelId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  draftId: Scalars['String'];
  planId: Scalars['String'];
  status: Scalars['String'];
};

export type CreateSnapshotInput = {
  capturedAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  distributionId: Scalars['String'];
  metric: Metric;
  note?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  value: Scalars['BigInt'];
};

export type CreateWorkflowTypeInput = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parameterSchema: Scalars['JSONObject'];
  webhookUrl: Scalars['String'];
};

export type CreateWorkflowTypeResponse = {
  __typename?: 'CreateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  workflowTypeId: Scalars['String'];
};

export type CurrentArtifactVersionResponse = {
  __typename?: 'CurrentArtifactVersionResponse';
  artifactId: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  title: Scalars['String'];
  versionNo: Scalars['Float'];
};

export type DateRangeInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type DeactivateWorkflowTypeResponse = {
  __typename?: 'DeactivateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteDraftInput = {
  draftId: Scalars['String'];
};

export type DeleteOriginalPostInput = {
  originalPostId: Scalars['String'];
};

export type DeletePlanInput = {
  draftId: Scalars['String'];
  planId: Scalars['String'];
};

export type DeletePostInput = {
  postId: Scalars['String'];
};

export type DistributionFilters = {
  channelId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  postId?: InputMaybe<Scalars['String']>;
  publishedFrom?: InputMaybe<Scalars['DateTime']>;
  publishedTo?: InputMaybe<Scalars['DateTime']>;
  sort?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DistributionStatus>;
};

export type DistributionListType = {
  __typename?: 'DistributionListType';
  items: Array<DistributionType>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

/** Distribution status values */
export enum DistributionStatus {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Published = 'PUBLISHED'
}

export type DistributionType = {
  __typename?: 'DistributionType';
  channelId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['String'];
  postId: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  status: DistributionStatus;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Domain object types that can trigger workflows */
export enum DomainObjectType {
  CrawlJob = 'CRAWL_JOB',
  Draft = 'DRAFT',
  OriginalPost = 'ORIGINAL_POST',
  Post = 'POST'
}

export type DraftResponse = {
  __typename?: 'DraftResponse';
  artifactId: Scalars['String'];
  artifactVersions?: Maybe<Array<ArtifactVersionResponse>>;
  contentMd?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  draftId: Scalars['String'];
  memo?: Maybe<Scalars['String']>;
  originalPostId: Scalars['String'];
  plans: Array<ChannelPostPlanOutput>;
  status: DraftStatus;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type DraftStats = {
  __typename?: 'DraftStats';
  averageTimeToApproval?: Maybe<Scalars['Float']>;
  byStatus: Array<StatusCount>;
  total: Scalars['Float'];
};

export enum DraftStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Editing = 'EDITING',
  New = 'NEW'
}

export type DraftSummary = {
  __typename?: 'DraftSummary';
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  artifactId: Scalars['String'];
  channelPostPlans: Array<ChannelPostPlanOutput>;
  createdAt: Scalars['DateTime'];
  draftId: Scalars['String'];
  originalPostId: Scalars['String'];
  status: DraftStatus;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type DraftsResponse = {
  __typename?: 'DraftsResponse';
  items: Array<DraftSummary>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  total: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ExecutionCallbackInput = {
  durationMs?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  executionId: Scalars['String'];
  result?: InputMaybe<Scalars['JSONObject']>;
  status: ExecutionStatus;
};

export type ExecutionCallbackResponse = {
  __typename?: 'ExecutionCallbackResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Workflow execution status */
export enum ExecutionStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type ExecutionStatusSummary = {
  __typename?: 'ExecutionStatusSummary';
  count: Scalars['Int'];
  status: ExecutionStatus;
};

export type GetConversationResponse = {
  __typename?: 'GetConversationResponse';
  conversationId: Scalars['String'];
  status: ConversationStatus;
};

export type GetLatestSnapshotsInput = {
  distributionId?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<Metric>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type HistoryOutput = {
  __typename?: 'HistoryOutput';
  items: Array<HistorySnapshotItem>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type HistorySnapshotItem = {
  __typename?: 'HistorySnapshotItem';
  capturedAt: Scalars['DateTime'];
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  value: Scalars['BigInt'];
  voided: Scalars['Boolean'];
};

export type LatestSnapshotItem = {
  __typename?: 'LatestSnapshotItem';
  distributionId: Scalars['String'];
  latestCapturedAt: Scalars['DateTime'];
  latestValue: Scalars['BigInt'];
  metric: Metric;
  snapshotId: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type LatestSnapshotsOutput = {
  __typename?: 'LatestSnapshotsOutput';
  items: Array<LatestSnapshotItem>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type ListArtifactsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};

export type ListChannelsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ChannelType>;
};

export type ListDraftsInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  originalPostId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchInput>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<DraftStatus>;
};

export type ListHistoryInput = {
  distributionId: Scalars['String'];
  from?: InputMaybe<Scalars['DateTime']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  metric?: InputMaybe<Metric>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type ListOriginalPostsInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchInput>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<OriginalPostStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ListPostsInput = {
  channelId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  draftId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchInput>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<PostStatus>;
};

export type MarkMultiplePostsReadyInput = {
  postIds: Array<Scalars['String']>;
};

export type MarkMultiplePostsReadyResponse = {
  __typename?: 'MarkMultiplePostsReadyResponse';
  failureCount: Scalars['Float'];
  results: Array<PostReadyResult>;
  successCount: Scalars['Float'];
};

export type MarkPostReadyInput = {
  postId: Scalars['String'];
};

export type MarkPostReadyResponse = {
  __typename?: 'MarkPostReadyResponse';
  markedAt: Scalars['DateTime'];
  markedBy: Scalars['String'];
  postId: Scalars['String'];
  status: PostStatus;
};

/** Performance metric types (VIEW, LIKE, COMMENT, etc.) */
export enum Metric {
  View = 'VIEW'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateChannel: Scalars['Boolean'];
  activateWorkflowType: ActivateWorkflowTypeResponse;
  approveDraft: ApproveDraftResponse;
  approveProposal: ApproveProposalResponse;
  changeDistributionStatus: DistributionType;
  commitManualEdit: CommitManualEditResponse;
  confirmPostPhotoUpload: PostPhotoType;
  createArtifact: CreateArtifactResponse;
  createCrawlTarget: Scalars['String'];
  createOriginalPost: CreateOriginalPostResponse;
  createPlan: CreatePlanResponse;
  createSnapshot: PerformanceSnapshotOutput;
  createWorkflowType: CreateWorkflowTypeResponse;
  deactivateChannel: Scalars['Boolean'];
  deactivateWorkflowType: DeactivateWorkflowTypeResponse;
  deleteDraft: Scalars['String'];
  deleteOriginalPost: Scalars['String'];
  deletePlan: Scalars['String'];
  deletePost: Scalars['String'];
  deletePostPhoto: Scalars['Boolean'];
  generatePostPhotoUploadUrl: PostPhotoUploadSessionType;
  markMultiplePostsReady: MarkMultiplePostsReadyResponse;
  markPostReady: MarkPostReadyResponse;
  postMessage: PostMessageResponse;
  processExecutionCallback: ExecutionCallbackResponse;
  registerChannel: RegisterChannelResult;
  registerDistribution: RegisterDistributionResponse;
  rejectProposal: RejectProposalResponse;
  renameChannel: Scalars['Boolean'];
  reopenDraft: DraftResponse;
  reorderPostPhotos: Scalars['Boolean'];
  requestCrawlJob: RequestCrawlJobResponse;
  requestDraftCreation: RequestDraftCreationResponse;
  requestPlanRendering: RequestPlanRenderingResponse;
  requestWorkflowExecution: RequestWorkflowExecutionResponse;
  selectOriginalPost: SelectOriginalPostResponse;
  updateCrawlTarget: UpdateCrawlTargetResponse;
  updateDistributionUrl: DistributionType;
  updateDraftMeta: UpdateDraftMetaResponse;
  updateOriginalPost: OriginalPostResponse;
  updatePostFormat: Scalars['Boolean'];
  updatePostMeta: UpdatePostMetaResponse;
  updateSnapshot: PerformanceSnapshotOutput;
  updateWorkflowType: UpdateWorkflowTypeResponse;
  voidSnapshot: PerformanceSnapshotOutput;
};


export type MutationActivateChannelArgs = {
  channelId: Scalars['String'];
};


export type MutationActivateWorkflowTypeArgs = {
  id: Scalars['String'];
};


export type MutationApproveDraftArgs = {
  input: ApproveDraftInput;
};


export type MutationApproveProposalArgs = {
  input: ApproveProposalInput;
};


export type MutationChangeDistributionStatusArgs = {
  distributionId: Scalars['String'];
  input: ChangeDistributionStatusInput;
};


export type MutationCommitManualEditArgs = {
  input: CommitManualEditInput;
};


export type MutationConfirmPostPhotoUploadArgs = {
  postId: Scalars['String'];
  uploadSessionId: Scalars['String'];
};


export type MutationCreateArtifactArgs = {
  input: CreateArtifactInput;
};


export type MutationCreateCrawlTargetArgs = {
  input: CreateCrawlTargetInput;
};


export type MutationCreateOriginalPostArgs = {
  input: CreateOriginalPostInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreateSnapshotArgs = {
  input: CreateSnapshotInput;
};


export type MutationCreateWorkflowTypeArgs = {
  input: CreateWorkflowTypeInput;
};


export type MutationDeactivateChannelArgs = {
  channelId: Scalars['String'];
};


export type MutationDeactivateWorkflowTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDraftArgs = {
  input: DeleteDraftInput;
};


export type MutationDeleteOriginalPostArgs = {
  input: DeleteOriginalPostInput;
};


export type MutationDeletePlanArgs = {
  input: DeletePlanInput;
};


export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


export type MutationDeletePostPhotoArgs = {
  photoId: Scalars['String'];
  postId: Scalars['String'];
};


export type MutationGeneratePostPhotoUploadUrlArgs = {
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  postId: Scalars['String'];
};


export type MutationMarkMultiplePostsReadyArgs = {
  input: MarkMultiplePostsReadyInput;
};


export type MutationMarkPostReadyArgs = {
  input: MarkPostReadyInput;
};


export type MutationPostMessageArgs = {
  input: PostMessageInput;
};


export type MutationProcessExecutionCallbackArgs = {
  input: ExecutionCallbackInput;
};


export type MutationRegisterChannelArgs = {
  input: RegisterChannelInput;
};


export type MutationRegisterDistributionArgs = {
  input: RegisterDistributionInput;
};


export type MutationRejectProposalArgs = {
  input: RejectProposalInput;
};


export type MutationRenameChannelArgs = {
  channelId: Scalars['String'];
  newName: Scalars['String'];
};


export type MutationReopenDraftArgs = {
  input: ReopenDraftInput;
};


export type MutationReorderPostPhotosArgs = {
  photoIds: Array<Scalars['String']>;
  postId: Scalars['String'];
};


export type MutationRequestCrawlJobArgs = {
  input: RequestCrawlJobInput;
};


export type MutationRequestDraftCreationArgs = {
  input: RequestDraftCreationInput;
};


export type MutationRequestPlanRenderingArgs = {
  input: RequestPlanRenderingInput;
};


export type MutationRequestWorkflowExecutionArgs = {
  input: RequestWorkflowExecutionInput;
};


export type MutationSelectOriginalPostArgs = {
  input: SelectOriginalPostInput;
};


export type MutationUpdateCrawlTargetArgs = {
  input: UpdateCrawlTargetInput;
};


export type MutationUpdateDistributionUrlArgs = {
  distributionId: Scalars['String'];
  input: UpdateDistributionUrlInput;
};


export type MutationUpdateDraftMetaArgs = {
  input: UpdateDraftMetaInput;
};


export type MutationUpdateOriginalPostArgs = {
  input: UpdateOriginalPostInput;
};


export type MutationUpdatePostFormatArgs = {
  channelId: Scalars['String'];
  newFormat: Scalars['String'];
};


export type MutationUpdatePostMetaArgs = {
  input: UpdatePostMetaInput;
};


export type MutationUpdateSnapshotArgs = {
  input: UpdateSnapshotInput;
};


export type MutationUpdateWorkflowTypeArgs = {
  id: Scalars['String'];
  input: UpdateWorkflowTypeInput;
};


export type MutationVoidSnapshotArgs = {
  input: VoidSnapshotInput;
};

export enum OriginKind {
  Blank = 'BLANK',
  Import = 'IMPORT',
  Llm = 'LLM',
  User = 'USER'
}

export type OriginalPostResponse = {
  __typename?: 'OriginalPostResponse';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  draft?: Maybe<DraftResponse>;
  draftCreationFailureCount: Scalars['Float'];
  memo?: Maybe<Scalars['String']>;
  originalPostId: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  sourceUrl: Scalars['String'];
  status: OriginalPostStatus;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type OriginalPostStats = {
  __typename?: 'OriginalPostStats';
  bySource: Array<StatusCount>;
  byStatus: Array<StatusCount>;
  total: Scalars['Float'];
};

export enum OriginalPostStatus {
  Deleted = 'DELETED',
  Drafted = 'DRAFTED',
  DraftRequested = 'DRAFT_REQUESTED',
  DraftRequestFailed = 'DRAFT_REQUEST_FAILED',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Rejected = 'REJECTED',
  Selected = 'SELECTED'
}

export type OriginalPostSummary = {
  __typename?: 'OriginalPostSummary';
  createdAt: Scalars['DateTime'];
  originalPostId: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  sourceUrl: Scalars['String'];
  status: OriginalPostStatus;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type OriginalPostsResponse = {
  __typename?: 'OriginalPostsResponse';
  items: Array<OriginalPostSummary>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  total: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type PagedChannelsGraphQl = {
  __typename?: 'PagedChannelsGraphQL';
  items: Array<ChannelSummaryGraphQl>;
  page: Scalars['Int'];
  size: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationInput = {
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
};

export type PerformanceSnapshotOutput = {
  __typename?: 'PerformanceSnapshotOutput';
  capturedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  distributionId: Scalars['String'];
  id: Scalars['String'];
  metric: Metric;
  note?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['BigInt'];
  voided: Scalars['Boolean'];
};

export type PostMessageInput = {
  artifactId: Scalars['String'];
  content: Scalars['String'];
  role: Role;
};

export type PostMessageResponse = {
  __typename?: 'PostMessageResponse';
  conversationId: Scalars['String'];
  messageId: Scalars['String'];
  proposalCreated: Scalars['Boolean'];
  proposalId?: Maybe<Scalars['String']>;
};

export type PostPhotoType = {
  __typename?: 'PostPhotoType';
  altText?: Maybe<Scalars['String']>;
  bucketName: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  objectName: Scalars['String'];
  postId: Scalars['ID'];
  signedUrl?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  storageFileId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type PostPhotoUploadSessionType = {
  __typename?: 'PostPhotoUploadSessionType';
  expiresAt: Scalars['DateTime'];
  uploadSessionId: Scalars['ID'];
  uploadUrl: Scalars['String'];
};

export type PostReadyResult = {
  __typename?: 'PostReadyResult';
  error?: Maybe<Scalars['String']>;
  markedAt?: Maybe<Scalars['DateTime']>;
  postId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PostResponse = {
  __typename?: 'PostResponse';
  artifactId: Scalars['String'];
  channelId: Scalars['String'];
  channelRef: ChannelRefOutput;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  draftId: Scalars['String'];
  memo?: Maybe<Scalars['String']>;
  postId: Scalars['String'];
  publishedBy?: Maybe<Scalars['String']>;
  status: PostStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PostStats = {
  __typename?: 'PostStats';
  byChannel: Array<ChannelCount>;
  byStatus: Array<StatusCount>;
  total: Scalars['Float'];
};

export enum PostStatus {
  Deleted = 'DELETED',
  Editing = 'EDITING',
  Published = 'PUBLISHED',
  Ready = 'READY'
}

export type PostSummary = {
  __typename?: 'PostSummary';
  channelId: Scalars['String'];
  channelRef: ChannelRefOutput;
  createdAt: Scalars['DateTime'];
  draftId: Scalars['String'];
  planId: Scalars['String'];
  postId: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<Scalars['String']>;
  readyMarkedAt?: Maybe<Scalars['DateTime']>;
  status: PostStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PostsResponse = {
  __typename?: 'PostsResponse';
  items: Array<PostSummary>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  total: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  channel: ChannelGraphQl;
  channels: PagedChannelsGraphQl;
  distribution: DistributionType;
  distributions: DistributionListType;
  draft: DraftResponse;
  drafts: DraftsResponse;
  getArtifact: ArtifactResponse;
  getArtifactVersionHistory: ArtifactVersionHistoryResponse;
  getContentPipelineStats: ContentPipelineStats;
  getConversation: GetConversationResponse;
  getCrawlTargets: CrawlTargetsResponse;
  getCurrentArtifactVersion: CurrentArtifactVersionResponse;
  getLatestSnapshots: LatestSnapshotsOutput;
  getOrStartConversation: GetConversationResponse;
  latestExecutionByObject?: Maybe<WorkflowExecutionType>;
  listArtifacts: ArtifactsResponse;
  listSnapshotHistory: HistoryOutput;
  originalPost: OriginalPostResponse;
  originalPosts: OriginalPostsResponse;
  post: PostResponse;
  postPhotoSignedUrl?: Maybe<Scalars['String']>;
  postPhotos: Array<PostPhotoType>;
  posts: PostsResponse;
  workflowExecution?: Maybe<WorkflowExecutionType>;
  workflowExecutionStats: WorkflowExecutionStats;
  workflowExecutions: WorkflowExecutionListType;
  workflowTypes: WorkflowTypeListType;
};


export type QueryChannelArgs = {
  id: Scalars['String'];
};


export type QueryChannelsArgs = {
  input?: InputMaybe<ListChannelsInput>;
};


export type QueryDistributionArgs = {
  id: Scalars['String'];
};


export type QueryDistributionsArgs = {
  filters?: InputMaybe<DistributionFilters>;
};


export type QueryDraftArgs = {
  draftId: Scalars['String'];
};


export type QueryDraftsArgs = {
  input?: InputMaybe<ListDraftsInput>;
};


export type QueryGetArtifactArgs = {
  artifactId: Scalars['String'];
};


export type QueryGetArtifactVersionHistoryArgs = {
  artifactId: Scalars['String'];
};


export type QueryGetContentPipelineStatsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryGetConversationArgs = {
  artifactId?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCrawlTargetsArgs = {
  filters?: InputMaybe<CrawlTargetFilters>;
};


export type QueryGetCurrentArtifactVersionArgs = {
  artifactId: Scalars['String'];
};


export type QueryGetLatestSnapshotsArgs = {
  input: GetLatestSnapshotsInput;
};


export type QueryGetOrStartConversationArgs = {
  artifactId: Scalars['String'];
};


export type QueryLatestExecutionByObjectArgs = {
  relatedObjectId: Scalars['String'];
  relatedObjectType: DomainObjectType;
};


export type QueryListArtifactsArgs = {
  input?: InputMaybe<ListArtifactsInput>;
};


export type QueryListSnapshotHistoryArgs = {
  input: ListHistoryInput;
};


export type QueryOriginalPostArgs = {
  originalPostId: Scalars['String'];
};


export type QueryOriginalPostsArgs = {
  filter?: InputMaybe<ListOriginalPostsInput>;
};


export type QueryPostArgs = {
  postId: Scalars['String'];
};


export type QueryPostPhotoSignedUrlArgs = {
  expiresInMinutes?: InputMaybe<Scalars['Float']>;
  photoId: Scalars['String'];
};


export type QueryPostPhotosArgs = {
  postId: Scalars['String'];
};


export type QueryPostsArgs = {
  input?: InputMaybe<ListPostsInput>;
};


export type QueryWorkflowExecutionArgs = {
  executionId: Scalars['String'];
};


export type QueryWorkflowExecutionStatsArgs = {
  filters?: InputMaybe<WorkflowExecutionFilters>;
};


export type QueryWorkflowExecutionsArgs = {
  filters?: InputMaybe<WorkflowExecutionFilters>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWorkflowTypesArgs = {
  filters?: InputMaybe<WorkflowTypeFilters>;
  pagination?: InputMaybe<PaginationInput>;
};

export type RegisterChannelInput = {
  name: Scalars['String'];
  postFormat: ContentFormat;
  type: ChannelType;
};

export type RegisterChannelResult = {
  __typename?: 'RegisterChannelResult';
  channelId: Scalars['String'];
};

export type RegisterDistributionInput = {
  channelId: Scalars['String'];
  createdBy: Scalars['String'];
  postId: Scalars['String'];
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type RegisterDistributionResponse = {
  __typename?: 'RegisterDistributionResponse';
  distribution?: Maybe<DistributionType>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RejectProposalInput = {
  artifactId: Scalars['String'];
  reason: Scalars['String'];
};

export type RejectProposalResponse = {
  __typename?: 'RejectProposalResponse';
  artifactId: Scalars['String'];
  rejected: Scalars['Boolean'];
};

export type ReopenDraftInput = {
  draftId: Scalars['String'];
};

export type RequestCrawlJobInput = {
  crawlTargetId: Scalars['String'];
};

export type RequestCrawlJobResponse = {
  __typename?: 'RequestCrawlJobResponse';
  crawlJobId: Scalars['String'];
};

export type RequestDraftCreationInput = {
  originalPostId: Scalars['String'];
};

export type RequestDraftCreationResponse = {
  __typename?: 'RequestDraftCreationResponse';
  executionId?: Maybe<Scalars['String']>;
  originalPostId: Scalars['String'];
  requestedAt: Scalars['DateTime'];
  status: OriginalPostStatus;
};

export type RequestPlanRenderingInput = {
  draftId: Scalars['String'];
  planId: Scalars['String'];
};

export type RequestPlanRenderingResponse = {
  __typename?: 'RequestPlanRenderingResponse';
  draftId: Scalars['String'];
  executionId?: Maybe<Scalars['String']>;
  planId: Scalars['String'];
  requestedAt: Scalars['DateTime'];
  status: Scalars['String'];
};

export type RequestWorkflowExecutionInput = {
  correlationId?: InputMaybe<Scalars['String']>;
  payload: Scalars['JSONObject'];
  relatedObjectId: Scalars['String'];
  relatedObjectType: DomainObjectType;
  workflowTypeCode: Scalars['String'];
};

export type RequestWorkflowExecutionResponse = {
  __typename?: 'RequestWorkflowExecutionResponse';
  executionId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum Role {
  Llm = 'LLM',
  User = 'USER'
}

export enum SearchFieldType {
  Content = 'CONTENT',
  Title = 'TITLE'
}

export type SearchInput = {
  fields?: InputMaybe<Array<SearchFieldType>>;
  keyword: Scalars['String'];
};

export type SelectOriginalPostInput = {
  originalPostId: Scalars['String'];
};

export type SelectOriginalPostResponse = {
  __typename?: 'SelectOriginalPostResponse';
  originalPostId: Scalars['String'];
  selectedAt: Scalars['DateTime'];
  selectedBy: Scalars['String'];
  status: OriginalPostStatus;
};

/** Sort order direction */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatusCount = {
  __typename?: 'StatusCount';
  count: Scalars['Float'];
  status: Scalars['String'];
};

export type UpdateCrawlTargetInput = {
  crawlTargetId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  workflowTypeCode?: InputMaybe<Scalars['String']>;
};

export type UpdateCrawlTargetResponse = {
  __typename?: 'UpdateCrawlTargetResponse';
  crawlTargetId: Scalars['String'];
  modifiedFields: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type UpdateDistributionUrlInput = {
  url: Scalars['String'];
};

export type UpdateDraftMetaInput = {
  draftId: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftMetaResponse = {
  __typename?: 'UpdateDraftMetaResponse';
  draftId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UpdateOriginalPostInput = {
  content?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  originalPostId: Scalars['String'];
  status?: InputMaybe<OriginalPostStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePostMetaInput = {
  content?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  postId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePostMetaResponse = {
  __typename?: 'UpdatePostMetaResponse';
  postId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UpdateSnapshotInput = {
  capturedAt: Scalars['DateTime'];
  note?: InputMaybe<Scalars['String']>;
  snapshotId: Scalars['String'];
  source: Scalars['String'];
  updatedBy: Scalars['String'];
  value: Scalars['BigInt'];
};

export type UpdateWorkflowTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parameterSchema?: InputMaybe<Scalars['JSONObject']>;
  webhookUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkflowTypeResponse = {
  __typename?: 'UpdateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type VoidSnapshotInput = {
  note?: InputMaybe<Scalars['String']>;
  snapshotId: Scalars['String'];
  voidedBy: Scalars['String'];
};

export type WorkflowExecutionFilters = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  relatedObjectId?: InputMaybe<Scalars['String']>;
  relatedObjectType?: InputMaybe<DomainObjectType>;
  status?: InputMaybe<ExecutionStatus>;
  workflowTypeCode?: InputMaybe<Scalars['String']>;
  workflowTypeId?: InputMaybe<Scalars['String']>;
};

export type WorkflowExecutionListType = {
  __typename?: 'WorkflowExecutionListType';
  items: Array<WorkflowExecutionType>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
};

export type WorkflowExecutionStats = {
  __typename?: 'WorkflowExecutionStats';
  averageDuration: Scalars['Float'];
  statusBreakdown: Array<ExecutionStatusSummary>;
  successRate: Scalars['Float'];
  totalExecutions: Scalars['Int'];
};

export type WorkflowExecutionType = {
  __typename?: 'WorkflowExecutionType';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  durationMs?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  executionId: Scalars['String'];
  payload: Scalars['JSONObject'];
  relatedObjectId: Scalars['String'];
  relatedObjectType: DomainObjectType;
  requestedAt: Scalars['DateTime'];
  result?: Maybe<Scalars['JSONObject']>;
  status: ExecutionStatus;
  updatedAt: Scalars['DateTime'];
  workflowTypeCode: Scalars['String'];
  workflowTypeId: Scalars['String'];
};

export type WorkflowStats = {
  __typename?: 'WorkflowStats';
  averageDuration?: Maybe<Scalars['Float']>;
  executionsCount: Scalars['Float'];
  successRate: Scalars['Float'];
};

export type WorkflowTypeFilters = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type WorkflowTypeListType = {
  __typename?: 'WorkflowTypeListType';
  items: Array<WorkflowTypeType>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
};

export type WorkflowTypeType = {
  __typename?: 'WorkflowTypeType';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  executionCount: Scalars['Int'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  parameterSchema: Scalars['JSONObject'];
  updatedAt: Scalars['DateTime'];
  webhookUrl: Scalars['String'];
};

export type OmniOriginalPostsQueryVariables = Exact<{
  filter: ListOriginalPostsInput;
}>;


export type OmniOriginalPostsQuery = { __typename?: 'Query', originalPosts: { __typename?: 'OriginalPostsResponse', limit: number, page: number, total: number, totalPages: number, items: Array<{ __typename?: 'OriginalPostSummary', originalPostId: string, title: string, publishedAt?: any | null, createdAt: any, updatedAt: any, sourceUrl: string, tags: Array<string>, status: OriginalPostStatus }> } };

export type OmniOriginalPostDetailQueryVariables = Exact<{
  originalPostId: Scalars['String'];
}>;


export type OmniOriginalPostDetailQuery = { __typename?: 'Query', originalPost: { __typename?: 'OriginalPostResponse', content: string, createdAt: any, draftCreationFailureCount: number, memo?: string | null, originalPostId: string, publishedAt?: any | null, sourceUrl: string, status: OriginalPostStatus, tags: Array<string>, title: string, updatedAt: any, updatedBy?: string | null } };

export type OmniSelectOriginalPostMutationVariables = Exact<{
  input: SelectOriginalPostInput;
}>;


export type OmniSelectOriginalPostMutation = { __typename?: 'Mutation', selectOriginalPost: { __typename?: 'SelectOriginalPostResponse', originalPostId: string, selectedAt: any, selectedBy: string, status: OriginalPostStatus } };

export type OmniUpdateOriginalPostMutationVariables = Exact<{
  input: UpdateOriginalPostInput;
}>;


export type OmniUpdateOriginalPostMutation = { __typename?: 'Mutation', updateOriginalPost: { __typename?: 'OriginalPostResponse', content: string, createdAt: any, draftCreationFailureCount: number, memo?: string | null, originalPostId: string, publishedAt?: any | null, sourceUrl: string, status: OriginalPostStatus, tags: Array<string>, title: string, updatedAt: any } };

export type OmniDeleteOriginalPostMutationVariables = Exact<{
  input: DeleteOriginalPostInput;
}>;


export type OmniDeleteOriginalPostMutation = { __typename?: 'Mutation', deleteOriginalPost: string };

export type OmniCreateOriginalPostMutationVariables = Exact<{
  input: CreateOriginalPostInput;
}>;


export type OmniCreateOriginalPostMutation = { __typename?: 'Mutation', createOriginalPost: { __typename?: 'CreateOriginalPostResponse', originalPostId: string, status: OriginalPostStatus, createdAt: any } };

export type OmniRequestDraftCreationMutationVariables = Exact<{
  input: RequestDraftCreationInput;
}>;


export type OmniRequestDraftCreationMutation = { __typename?: 'Mutation', requestDraftCreation: { __typename?: 'RequestDraftCreationResponse', originalPostId: string, executionId?: string | null, status: OriginalPostStatus, requestedAt: any } };

export type OmniDraftsQueryVariables = Exact<{
  input: ListDraftsInput;
}>;


export type OmniDraftsQuery = { __typename?: 'Query', drafts: { __typename?: 'DraftsResponse', limit: number, page: number, total: number, totalPages: number, items: Array<{ __typename?: 'DraftSummary', draftId: string, title: string, status: DraftStatus, createdAt: any, updatedAt: any, originalPostId: string, tags: Array<string>, artifactId: string, channelPostPlans: Array<{ __typename?: 'ChannelPostPlanOutput', planId: string, channelId: string, status: string, channelRef: { __typename?: 'ChannelRefOutput', name: string } }> }> } };

export type OmniDraftQueryVariables = Exact<{
  draftId: Scalars['String'];
}>;


export type OmniDraftQuery = { __typename?: 'Query', draft: { __typename?: 'DraftResponse', draftId: string, title: string, contentMd?: string | null, status: DraftStatus, createdAt: any, updatedAt: any, updatedBy?: string | null, originalPostId: string, memo?: string | null, tags: Array<string>, artifactId: string, artifactVersions?: Array<{ __typename?: 'ArtifactVersionResponse', versionNo: number, content: string, memo?: string | null, createdAt: any }> | null, plans: Array<{ __typename?: 'ChannelPostPlanOutput', planId: string, channelId: string, postId?: string | null, status: string, statusDescription?: string | null, requestedAt?: any | null }> } };

export type OmniDeleteDraftMutationVariables = Exact<{
  input: DeleteDraftInput;
}>;


export type OmniDeleteDraftMutation = { __typename?: 'Mutation', deleteDraft: string };

export type OmniCommitManualEditMutationVariables = Exact<{
  input: CommitManualEditInput;
}>;


export type OmniCommitManualEditMutation = { __typename?: 'Mutation', commitManualEdit: { __typename?: 'CommitManualEditResponse', artifactId: string, versionNo: number } };

export type OmniUpdateDraftMetaMutationVariables = Exact<{
  input: UpdateDraftMetaInput;
}>;


export type OmniUpdateDraftMetaMutation = { __typename?: 'Mutation', updateDraftMeta: { __typename?: 'UpdateDraftMetaResponse', draftId: string, updatedAt: any } };

export type OmniApproveDraftMutationVariables = Exact<{
  input: ApproveDraftInput;
}>;


export type OmniApproveDraftMutation = { __typename?: 'Mutation', approveDraft: { __typename?: 'ApproveDraftResponse', draftId: string, status: DraftStatus, approvedAt: any, approvedBy: string } };

export type OmniReopenDraftMutationVariables = Exact<{
  input: ReopenDraftInput;
}>;


export type OmniReopenDraftMutation = { __typename?: 'Mutation', reopenDraft: { __typename?: 'DraftResponse', draftId: string, status: DraftStatus } };

export type OmniPostsQueryVariables = Exact<{
  input: ListPostsInput;
}>;


export type OmniPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResponse', limit: number, page: number, total: number, totalPages: number, items: Array<{ __typename?: 'PostSummary', postId: string, title: string, status: PostStatus, channelId: string, draftId: string, createdAt: any, updatedAt: any, channelRef: { __typename?: 'ChannelRefOutput', name: string } }> } };

export type OmniPostQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type OmniPostQuery = { __typename?: 'Query', post: { __typename?: 'PostResponse', postId: string, title: string, content: string, status: PostStatus, channelId: string, draftId: string, createdAt: any, updatedAt: any, updatedBy?: string | null, memo?: string | null, channelRef: { __typename?: 'ChannelRefOutput', name: string } } };

export type OmniUpdatePostMetaMutationVariables = Exact<{
  input: UpdatePostMetaInput;
}>;


export type OmniUpdatePostMetaMutation = { __typename?: 'Mutation', updatePostMeta: { __typename?: 'UpdatePostMetaResponse', postId: string, updatedAt: any } };

export type OmniDeletePostMutationVariables = Exact<{
  input: DeletePostInput;
}>;


export type OmniDeletePostMutation = { __typename?: 'Mutation', deletePost: string };

export type OmniMarkMultiplePostsReadyMutationVariables = Exact<{
  input: MarkMultiplePostsReadyInput;
}>;


export type OmniMarkMultiplePostsReadyMutation = { __typename?: 'Mutation', markMultiplePostsReady: { __typename?: 'MarkMultiplePostsReadyResponse', failureCount: number, successCount: number, results: Array<{ __typename?: 'PostReadyResult', error?: string | null, markedAt?: any | null, postId: string, success: boolean }> } };

export type OmniRegisterDistributionMutationVariables = Exact<{
  input: RegisterDistributionInput;
}>;


export type OmniRegisterDistributionMutation = { __typename?: 'Mutation', registerDistribution: { __typename?: 'RegisterDistributionResponse', message?: string | null, success: boolean, distribution?: { __typename?: 'DistributionType', channelId: string, createdAt: any, createdBy: string, id: string, postId: string, publishedAt?: any | null, status: DistributionStatus, updatedAt: any, url: string } | null } };

export type OmniCreatePlanMutationVariables = Exact<{
  input: CreatePlanInput;
}>;


export type OmniCreatePlanMutation = { __typename?: 'Mutation', createPlan: { __typename?: 'CreatePlanResponse', planId: string, draftId: string, channelId: string, status: string, createdAt: any } };

export type OmniRequestPlanRenderingMutationVariables = Exact<{
  input: RequestPlanRenderingInput;
}>;


export type OmniRequestPlanRenderingMutation = { __typename?: 'Mutation', requestPlanRendering: { __typename?: 'RequestPlanRenderingResponse', planId: string, executionId?: string | null, status: string, requestedAt: any } };

export type OmniChannelsQueryVariables = Exact<{
  input: ListChannelsInput;
}>;


export type OmniChannelsQuery = { __typename?: 'Query', channels: { __typename?: 'PagedChannelsGraphQL', page: number, total: number, items: Array<{ __typename?: 'ChannelSummaryGraphQL', id: string, name: string, type: ChannelType, active: boolean }> } };

export type OmniChannelQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OmniChannelQuery = { __typename?: 'Query', channel: { __typename?: 'ChannelGraphQL', id: string, name: string, type: ChannelType, active: boolean } };

export type OmniWorkflowTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type OmniWorkflowTypesQuery = { __typename?: 'Query', workflowTypes: { __typename?: 'WorkflowTypeListType', items: Array<{ __typename?: 'WorkflowTypeType', id: string, code: string, name: string, description?: string | null, isActive: boolean }> } };

export type OmniDistributionsQueryVariables = Exact<{
  filters: DistributionFilters;
}>;


export type OmniDistributionsQuery = { __typename?: 'Query', distributions: { __typename?: 'DistributionListType', total: number, page: number, pageSize: number, items: Array<{ __typename?: 'DistributionType', id: string, postId: string, channelId: string, url: string, status: DistributionStatus, publishedAt?: any | null, createdBy: string, createdAt: any, updatedBy?: string | null, updatedAt: any }> } };

export type OmniUpdateDistributionUrlMutationVariables = Exact<{
  distributionId: Scalars['String'];
  input: UpdateDistributionUrlInput;
}>;


export type OmniUpdateDistributionUrlMutation = { __typename?: 'Mutation', updateDistributionUrl: { __typename?: 'DistributionType', channelId: string, createdAt: any, createdBy: string, id: string, postId: string, publishedAt?: any | null, status: DistributionStatus, updatedAt: any, url: string } };

export type OmniGeneratePostPhotoUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  postId: Scalars['String'];
}>;


export type OmniGeneratePostPhotoUploadUrlMutation = { __typename?: 'Mutation', generatePostPhotoUploadUrl: { __typename?: 'PostPhotoUploadSessionType', expiresAt: any, uploadSessionId: string, uploadUrl: string } };

export type OmniConfirmPostPhotoUploadMutationVariables = Exact<{
  postId: Scalars['String'];
  uploadSessionId: Scalars['String'];
}>;


export type OmniConfirmPostPhotoUploadMutation = { __typename?: 'Mutation', confirmPostPhotoUpload: { __typename?: 'PostPhotoType', altText?: string | null, bucketName: string, caption?: string | null, createdAt: any, displayOrder: number, id: string, mimeType: string, objectName: string, postId: string, size: number, storageFileId: string, updatedAt: any } };

export type OmniDeletePostPhotoMutationVariables = Exact<{
  photoId: Scalars['String'];
  postId: Scalars['String'];
}>;


export type OmniDeletePostPhotoMutation = { __typename?: 'Mutation', deletePostPhoto: boolean };

export type OmniPostPhotosQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type OmniPostPhotosQuery = { __typename?: 'Query', postPhotos: Array<{ __typename?: 'PostPhotoType', altText?: string | null, bucketName: string, caption?: string | null, createdAt: any, displayOrder: number, id: string, mimeType: string, objectName: string, postId: string, size: number, storageFileId: string, updatedAt: any, signedUrl?: string | null, expiresAt?: any | null }> };

export type OmniCreateSnapshotMutationVariables = Exact<{
  input: CreateSnapshotInput;
}>;


export type OmniCreateSnapshotMutation = { __typename?: 'Mutation', createSnapshot: { __typename?: 'PerformanceSnapshotOutput', id: string, distributionId: string, metric: Metric, value: any, capturedAt: any, source: string, note?: string | null, voided: boolean, createdBy: string, createdAt: any, updatedAt: any } };

export type OmniListSnapshotHistoryQueryVariables = Exact<{
  input: ListHistoryInput;
}>;


export type OmniListSnapshotHistoryQuery = { __typename?: 'Query', listSnapshotHistory: { __typename?: 'HistoryOutput', page: number, pageSize: number, total: number, items: Array<{ __typename?: 'HistorySnapshotItem', capturedAt: any, id: string, note?: string | null, source: string, value: any, voided: boolean }> } };


export const OmniOriginalPostsDocument = gql`
    query OmniOriginalPosts($filter: ListOriginalPostsInput!) {
  originalPosts(filter: $filter) {
    items {
      originalPostId
      title
      publishedAt
      createdAt
      updatedAt
      sourceUrl
      tags
      status
    }
    limit
    page
    total
    totalPages
  }
}
    `;

/**
 * __useOmniOriginalPostsQuery__
 *
 * To run a query within a React component, call `useOmniOriginalPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniOriginalPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniOriginalPostsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOmniOriginalPostsQuery(baseOptions: Apollo.QueryHookOptions<OmniOriginalPostsQuery, OmniOriginalPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniOriginalPostsQuery, OmniOriginalPostsQueryVariables>(OmniOriginalPostsDocument, options);
      }
export function useOmniOriginalPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniOriginalPostsQuery, OmniOriginalPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniOriginalPostsQuery, OmniOriginalPostsQueryVariables>(OmniOriginalPostsDocument, options);
        }
export type OmniOriginalPostsQueryHookResult = ReturnType<typeof useOmniOriginalPostsQuery>;
export type OmniOriginalPostsLazyQueryHookResult = ReturnType<typeof useOmniOriginalPostsLazyQuery>;
export type OmniOriginalPostsQueryResult = Apollo.QueryResult<OmniOriginalPostsQuery, OmniOriginalPostsQueryVariables>;
export const OmniOriginalPostDetailDocument = gql`
    query OmniOriginalPostDetail($originalPostId: String!) {
  originalPost(originalPostId: $originalPostId) {
    content
    createdAt
    draftCreationFailureCount
    memo
    originalPostId
    publishedAt
    sourceUrl
    status
    tags
    title
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useOmniOriginalPostDetailQuery__
 *
 * To run a query within a React component, call `useOmniOriginalPostDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniOriginalPostDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniOriginalPostDetailQuery({
 *   variables: {
 *      originalPostId: // value for 'originalPostId'
 *   },
 * });
 */
export function useOmniOriginalPostDetailQuery(baseOptions: Apollo.QueryHookOptions<OmniOriginalPostDetailQuery, OmniOriginalPostDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniOriginalPostDetailQuery, OmniOriginalPostDetailQueryVariables>(OmniOriginalPostDetailDocument, options);
      }
export function useOmniOriginalPostDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniOriginalPostDetailQuery, OmniOriginalPostDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniOriginalPostDetailQuery, OmniOriginalPostDetailQueryVariables>(OmniOriginalPostDetailDocument, options);
        }
export type OmniOriginalPostDetailQueryHookResult = ReturnType<typeof useOmniOriginalPostDetailQuery>;
export type OmniOriginalPostDetailLazyQueryHookResult = ReturnType<typeof useOmniOriginalPostDetailLazyQuery>;
export type OmniOriginalPostDetailQueryResult = Apollo.QueryResult<OmniOriginalPostDetailQuery, OmniOriginalPostDetailQueryVariables>;
export const OmniSelectOriginalPostDocument = gql`
    mutation OmniSelectOriginalPost($input: SelectOriginalPostInput!) {
  selectOriginalPost(input: $input) {
    originalPostId
    selectedAt
    selectedBy
    status
  }
}
    `;
export type OmniSelectOriginalPostMutationFn = Apollo.MutationFunction<OmniSelectOriginalPostMutation, OmniSelectOriginalPostMutationVariables>;

/**
 * __useOmniSelectOriginalPostMutation__
 *
 * To run a mutation, you first call `useOmniSelectOriginalPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniSelectOriginalPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniSelectOriginalPostMutation, { data, loading, error }] = useOmniSelectOriginalPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniSelectOriginalPostMutation(baseOptions?: Apollo.MutationHookOptions<OmniSelectOriginalPostMutation, OmniSelectOriginalPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniSelectOriginalPostMutation, OmniSelectOriginalPostMutationVariables>(OmniSelectOriginalPostDocument, options);
      }
export type OmniSelectOriginalPostMutationHookResult = ReturnType<typeof useOmniSelectOriginalPostMutation>;
export type OmniSelectOriginalPostMutationResult = Apollo.MutationResult<OmniSelectOriginalPostMutation>;
export type OmniSelectOriginalPostMutationOptions = Apollo.BaseMutationOptions<OmniSelectOriginalPostMutation, OmniSelectOriginalPostMutationVariables>;
export const OmniUpdateOriginalPostDocument = gql`
    mutation OmniUpdateOriginalPost($input: UpdateOriginalPostInput!) {
  updateOriginalPost(input: $input) {
    content
    createdAt
    draftCreationFailureCount
    memo
    originalPostId
    publishedAt
    sourceUrl
    status
    tags
    title
    updatedAt
  }
}
    `;
export type OmniUpdateOriginalPostMutationFn = Apollo.MutationFunction<OmniUpdateOriginalPostMutation, OmniUpdateOriginalPostMutationVariables>;

/**
 * __useOmniUpdateOriginalPostMutation__
 *
 * To run a mutation, you first call `useOmniUpdateOriginalPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniUpdateOriginalPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniUpdateOriginalPostMutation, { data, loading, error }] = useOmniUpdateOriginalPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniUpdateOriginalPostMutation(baseOptions?: Apollo.MutationHookOptions<OmniUpdateOriginalPostMutation, OmniUpdateOriginalPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniUpdateOriginalPostMutation, OmniUpdateOriginalPostMutationVariables>(OmniUpdateOriginalPostDocument, options);
      }
export type OmniUpdateOriginalPostMutationHookResult = ReturnType<typeof useOmniUpdateOriginalPostMutation>;
export type OmniUpdateOriginalPostMutationResult = Apollo.MutationResult<OmniUpdateOriginalPostMutation>;
export type OmniUpdateOriginalPostMutationOptions = Apollo.BaseMutationOptions<OmniUpdateOriginalPostMutation, OmniUpdateOriginalPostMutationVariables>;
export const OmniDeleteOriginalPostDocument = gql`
    mutation OmniDeleteOriginalPost($input: DeleteOriginalPostInput!) {
  deleteOriginalPost(input: $input)
}
    `;
export type OmniDeleteOriginalPostMutationFn = Apollo.MutationFunction<OmniDeleteOriginalPostMutation, OmniDeleteOriginalPostMutationVariables>;

/**
 * __useOmniDeleteOriginalPostMutation__
 *
 * To run a mutation, you first call `useOmniDeleteOriginalPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniDeleteOriginalPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniDeleteOriginalPostMutation, { data, loading, error }] = useOmniDeleteOriginalPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniDeleteOriginalPostMutation(baseOptions?: Apollo.MutationHookOptions<OmniDeleteOriginalPostMutation, OmniDeleteOriginalPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniDeleteOriginalPostMutation, OmniDeleteOriginalPostMutationVariables>(OmniDeleteOriginalPostDocument, options);
      }
export type OmniDeleteOriginalPostMutationHookResult = ReturnType<typeof useOmniDeleteOriginalPostMutation>;
export type OmniDeleteOriginalPostMutationResult = Apollo.MutationResult<OmniDeleteOriginalPostMutation>;
export type OmniDeleteOriginalPostMutationOptions = Apollo.BaseMutationOptions<OmniDeleteOriginalPostMutation, OmniDeleteOriginalPostMutationVariables>;
export const OmniCreateOriginalPostDocument = gql`
    mutation OmniCreateOriginalPost($input: CreateOriginalPostInput!) {
  createOriginalPost(input: $input) {
    originalPostId
    status
    createdAt
  }
}
    `;
export type OmniCreateOriginalPostMutationFn = Apollo.MutationFunction<OmniCreateOriginalPostMutation, OmniCreateOriginalPostMutationVariables>;

/**
 * __useOmniCreateOriginalPostMutation__
 *
 * To run a mutation, you first call `useOmniCreateOriginalPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniCreateOriginalPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniCreateOriginalPostMutation, { data, loading, error }] = useOmniCreateOriginalPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniCreateOriginalPostMutation(baseOptions?: Apollo.MutationHookOptions<OmniCreateOriginalPostMutation, OmniCreateOriginalPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniCreateOriginalPostMutation, OmniCreateOriginalPostMutationVariables>(OmniCreateOriginalPostDocument, options);
      }
export type OmniCreateOriginalPostMutationHookResult = ReturnType<typeof useOmniCreateOriginalPostMutation>;
export type OmniCreateOriginalPostMutationResult = Apollo.MutationResult<OmniCreateOriginalPostMutation>;
export type OmniCreateOriginalPostMutationOptions = Apollo.BaseMutationOptions<OmniCreateOriginalPostMutation, OmniCreateOriginalPostMutationVariables>;
export const OmniRequestDraftCreationDocument = gql`
    mutation OmniRequestDraftCreation($input: RequestDraftCreationInput!) {
  requestDraftCreation(input: $input) {
    originalPostId
    executionId
    status
    requestedAt
  }
}
    `;
export type OmniRequestDraftCreationMutationFn = Apollo.MutationFunction<OmniRequestDraftCreationMutation, OmniRequestDraftCreationMutationVariables>;

/**
 * __useOmniRequestDraftCreationMutation__
 *
 * To run a mutation, you first call `useOmniRequestDraftCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniRequestDraftCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniRequestDraftCreationMutation, { data, loading, error }] = useOmniRequestDraftCreationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniRequestDraftCreationMutation(baseOptions?: Apollo.MutationHookOptions<OmniRequestDraftCreationMutation, OmniRequestDraftCreationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniRequestDraftCreationMutation, OmniRequestDraftCreationMutationVariables>(OmniRequestDraftCreationDocument, options);
      }
export type OmniRequestDraftCreationMutationHookResult = ReturnType<typeof useOmniRequestDraftCreationMutation>;
export type OmniRequestDraftCreationMutationResult = Apollo.MutationResult<OmniRequestDraftCreationMutation>;
export type OmniRequestDraftCreationMutationOptions = Apollo.BaseMutationOptions<OmniRequestDraftCreationMutation, OmniRequestDraftCreationMutationVariables>;
export const OmniDraftsDocument = gql`
    query OmniDrafts($input: ListDraftsInput!) {
  drafts(input: $input) {
    items {
      draftId
      title
      status
      createdAt
      updatedAt
      originalPostId
      tags
      artifactId
      channelPostPlans {
        planId
        channelId
        status
        channelRef {
          name
        }
      }
    }
    limit
    page
    total
    totalPages
  }
}
    `;

/**
 * __useOmniDraftsQuery__
 *
 * To run a query within a React component, call `useOmniDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniDraftsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniDraftsQuery(baseOptions: Apollo.QueryHookOptions<OmniDraftsQuery, OmniDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniDraftsQuery, OmniDraftsQueryVariables>(OmniDraftsDocument, options);
      }
export function useOmniDraftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniDraftsQuery, OmniDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniDraftsQuery, OmniDraftsQueryVariables>(OmniDraftsDocument, options);
        }
export type OmniDraftsQueryHookResult = ReturnType<typeof useOmniDraftsQuery>;
export type OmniDraftsLazyQueryHookResult = ReturnType<typeof useOmniDraftsLazyQuery>;
export type OmniDraftsQueryResult = Apollo.QueryResult<OmniDraftsQuery, OmniDraftsQueryVariables>;
export const OmniDraftDocument = gql`
    query OmniDraft($draftId: String!) {
  draft(draftId: $draftId) {
    draftId
    title
    contentMd
    status
    createdAt
    updatedAt
    updatedBy
    originalPostId
    memo
    tags
    artifactId
    artifactVersions {
      versionNo
      content
      memo
      createdAt
    }
    plans {
      planId
      channelId
      postId
      status
      statusDescription
      requestedAt
    }
  }
}
    `;

/**
 * __useOmniDraftQuery__
 *
 * To run a query within a React component, call `useOmniDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniDraftQuery({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useOmniDraftQuery(baseOptions: Apollo.QueryHookOptions<OmniDraftQuery, OmniDraftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniDraftQuery, OmniDraftQueryVariables>(OmniDraftDocument, options);
      }
export function useOmniDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniDraftQuery, OmniDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniDraftQuery, OmniDraftQueryVariables>(OmniDraftDocument, options);
        }
export type OmniDraftQueryHookResult = ReturnType<typeof useOmniDraftQuery>;
export type OmniDraftLazyQueryHookResult = ReturnType<typeof useOmniDraftLazyQuery>;
export type OmniDraftQueryResult = Apollo.QueryResult<OmniDraftQuery, OmniDraftQueryVariables>;
export const OmniDeleteDraftDocument = gql`
    mutation OmniDeleteDraft($input: DeleteDraftInput!) {
  deleteDraft(input: $input)
}
    `;
export type OmniDeleteDraftMutationFn = Apollo.MutationFunction<OmniDeleteDraftMutation, OmniDeleteDraftMutationVariables>;

/**
 * __useOmniDeleteDraftMutation__
 *
 * To run a mutation, you first call `useOmniDeleteDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniDeleteDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniDeleteDraftMutation, { data, loading, error }] = useOmniDeleteDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniDeleteDraftMutation(baseOptions?: Apollo.MutationHookOptions<OmniDeleteDraftMutation, OmniDeleteDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniDeleteDraftMutation, OmniDeleteDraftMutationVariables>(OmniDeleteDraftDocument, options);
      }
export type OmniDeleteDraftMutationHookResult = ReturnType<typeof useOmniDeleteDraftMutation>;
export type OmniDeleteDraftMutationResult = Apollo.MutationResult<OmniDeleteDraftMutation>;
export type OmniDeleteDraftMutationOptions = Apollo.BaseMutationOptions<OmniDeleteDraftMutation, OmniDeleteDraftMutationVariables>;
export const OmniCommitManualEditDocument = gql`
    mutation OmniCommitManualEdit($input: CommitManualEditInput!) {
  commitManualEdit(input: $input) {
    artifactId
    versionNo
  }
}
    `;
export type OmniCommitManualEditMutationFn = Apollo.MutationFunction<OmniCommitManualEditMutation, OmniCommitManualEditMutationVariables>;

/**
 * __useOmniCommitManualEditMutation__
 *
 * To run a mutation, you first call `useOmniCommitManualEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniCommitManualEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniCommitManualEditMutation, { data, loading, error }] = useOmniCommitManualEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniCommitManualEditMutation(baseOptions?: Apollo.MutationHookOptions<OmniCommitManualEditMutation, OmniCommitManualEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniCommitManualEditMutation, OmniCommitManualEditMutationVariables>(OmniCommitManualEditDocument, options);
      }
export type OmniCommitManualEditMutationHookResult = ReturnType<typeof useOmniCommitManualEditMutation>;
export type OmniCommitManualEditMutationResult = Apollo.MutationResult<OmniCommitManualEditMutation>;
export type OmniCommitManualEditMutationOptions = Apollo.BaseMutationOptions<OmniCommitManualEditMutation, OmniCommitManualEditMutationVariables>;
export const OmniUpdateDraftMetaDocument = gql`
    mutation OmniUpdateDraftMeta($input: UpdateDraftMetaInput!) {
  updateDraftMeta(input: $input) {
    draftId
    updatedAt
  }
}
    `;
export type OmniUpdateDraftMetaMutationFn = Apollo.MutationFunction<OmniUpdateDraftMetaMutation, OmniUpdateDraftMetaMutationVariables>;

/**
 * __useOmniUpdateDraftMetaMutation__
 *
 * To run a mutation, you first call `useOmniUpdateDraftMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniUpdateDraftMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniUpdateDraftMetaMutation, { data, loading, error }] = useOmniUpdateDraftMetaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniUpdateDraftMetaMutation(baseOptions?: Apollo.MutationHookOptions<OmniUpdateDraftMetaMutation, OmniUpdateDraftMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniUpdateDraftMetaMutation, OmniUpdateDraftMetaMutationVariables>(OmniUpdateDraftMetaDocument, options);
      }
export type OmniUpdateDraftMetaMutationHookResult = ReturnType<typeof useOmniUpdateDraftMetaMutation>;
export type OmniUpdateDraftMetaMutationResult = Apollo.MutationResult<OmniUpdateDraftMetaMutation>;
export type OmniUpdateDraftMetaMutationOptions = Apollo.BaseMutationOptions<OmniUpdateDraftMetaMutation, OmniUpdateDraftMetaMutationVariables>;
export const OmniApproveDraftDocument = gql`
    mutation OmniApproveDraft($input: ApproveDraftInput!) {
  approveDraft(input: $input) {
    draftId
    status
    approvedAt
    approvedBy
  }
}
    `;
export type OmniApproveDraftMutationFn = Apollo.MutationFunction<OmniApproveDraftMutation, OmniApproveDraftMutationVariables>;

/**
 * __useOmniApproveDraftMutation__
 *
 * To run a mutation, you first call `useOmniApproveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniApproveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniApproveDraftMutation, { data, loading, error }] = useOmniApproveDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniApproveDraftMutation(baseOptions?: Apollo.MutationHookOptions<OmniApproveDraftMutation, OmniApproveDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniApproveDraftMutation, OmniApproveDraftMutationVariables>(OmniApproveDraftDocument, options);
      }
export type OmniApproveDraftMutationHookResult = ReturnType<typeof useOmniApproveDraftMutation>;
export type OmniApproveDraftMutationResult = Apollo.MutationResult<OmniApproveDraftMutation>;
export type OmniApproveDraftMutationOptions = Apollo.BaseMutationOptions<OmniApproveDraftMutation, OmniApproveDraftMutationVariables>;
export const OmniReopenDraftDocument = gql`
    mutation OmniReopenDraft($input: ReopenDraftInput!) {
  reopenDraft(input: $input) {
    draftId
    status
  }
}
    `;
export type OmniReopenDraftMutationFn = Apollo.MutationFunction<OmniReopenDraftMutation, OmniReopenDraftMutationVariables>;

/**
 * __useOmniReopenDraftMutation__
 *
 * To run a mutation, you first call `useOmniReopenDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniReopenDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniReopenDraftMutation, { data, loading, error }] = useOmniReopenDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniReopenDraftMutation(baseOptions?: Apollo.MutationHookOptions<OmniReopenDraftMutation, OmniReopenDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniReopenDraftMutation, OmniReopenDraftMutationVariables>(OmniReopenDraftDocument, options);
      }
export type OmniReopenDraftMutationHookResult = ReturnType<typeof useOmniReopenDraftMutation>;
export type OmniReopenDraftMutationResult = Apollo.MutationResult<OmniReopenDraftMutation>;
export type OmniReopenDraftMutationOptions = Apollo.BaseMutationOptions<OmniReopenDraftMutation, OmniReopenDraftMutationVariables>;
export const OmniPostsDocument = gql`
    query OmniPosts($input: ListPostsInput!) {
  posts(input: $input) {
    items {
      postId
      title
      status
      channelId
      draftId
      createdAt
      updatedAt
      channelRef {
        name
      }
    }
    limit
    page
    total
    totalPages
  }
}
    `;

/**
 * __useOmniPostsQuery__
 *
 * To run a query within a React component, call `useOmniPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniPostsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniPostsQuery(baseOptions: Apollo.QueryHookOptions<OmniPostsQuery, OmniPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniPostsQuery, OmniPostsQueryVariables>(OmniPostsDocument, options);
      }
export function useOmniPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniPostsQuery, OmniPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniPostsQuery, OmniPostsQueryVariables>(OmniPostsDocument, options);
        }
export type OmniPostsQueryHookResult = ReturnType<typeof useOmniPostsQuery>;
export type OmniPostsLazyQueryHookResult = ReturnType<typeof useOmniPostsLazyQuery>;
export type OmniPostsQueryResult = Apollo.QueryResult<OmniPostsQuery, OmniPostsQueryVariables>;
export const OmniPostDocument = gql`
    query OmniPost($postId: String!) {
  post(postId: $postId) {
    postId
    title
    content
    status
    channelId
    draftId
    createdAt
    updatedAt
    updatedBy
    memo
    channelRef {
      name
    }
  }
}
    `;

/**
 * __useOmniPostQuery__
 *
 * To run a query within a React component, call `useOmniPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useOmniPostQuery(baseOptions: Apollo.QueryHookOptions<OmniPostQuery, OmniPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniPostQuery, OmniPostQueryVariables>(OmniPostDocument, options);
      }
export function useOmniPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniPostQuery, OmniPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniPostQuery, OmniPostQueryVariables>(OmniPostDocument, options);
        }
export type OmniPostQueryHookResult = ReturnType<typeof useOmniPostQuery>;
export type OmniPostLazyQueryHookResult = ReturnType<typeof useOmniPostLazyQuery>;
export type OmniPostQueryResult = Apollo.QueryResult<OmniPostQuery, OmniPostQueryVariables>;
export const OmniUpdatePostMetaDocument = gql`
    mutation OmniUpdatePostMeta($input: UpdatePostMetaInput!) {
  updatePostMeta(input: $input) {
    postId
    updatedAt
  }
}
    `;
export type OmniUpdatePostMetaMutationFn = Apollo.MutationFunction<OmniUpdatePostMetaMutation, OmniUpdatePostMetaMutationVariables>;

/**
 * __useOmniUpdatePostMetaMutation__
 *
 * To run a mutation, you first call `useOmniUpdatePostMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniUpdatePostMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniUpdatePostMetaMutation, { data, loading, error }] = useOmniUpdatePostMetaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniUpdatePostMetaMutation(baseOptions?: Apollo.MutationHookOptions<OmniUpdatePostMetaMutation, OmniUpdatePostMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniUpdatePostMetaMutation, OmniUpdatePostMetaMutationVariables>(OmniUpdatePostMetaDocument, options);
      }
export type OmniUpdatePostMetaMutationHookResult = ReturnType<typeof useOmniUpdatePostMetaMutation>;
export type OmniUpdatePostMetaMutationResult = Apollo.MutationResult<OmniUpdatePostMetaMutation>;
export type OmniUpdatePostMetaMutationOptions = Apollo.BaseMutationOptions<OmniUpdatePostMetaMutation, OmniUpdatePostMetaMutationVariables>;
export const OmniDeletePostDocument = gql`
    mutation OmniDeletePost($input: DeletePostInput!) {
  deletePost(input: $input)
}
    `;
export type OmniDeletePostMutationFn = Apollo.MutationFunction<OmniDeletePostMutation, OmniDeletePostMutationVariables>;

/**
 * __useOmniDeletePostMutation__
 *
 * To run a mutation, you first call `useOmniDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniDeletePostMutation, { data, loading, error }] = useOmniDeletePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<OmniDeletePostMutation, OmniDeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniDeletePostMutation, OmniDeletePostMutationVariables>(OmniDeletePostDocument, options);
      }
export type OmniDeletePostMutationHookResult = ReturnType<typeof useOmniDeletePostMutation>;
export type OmniDeletePostMutationResult = Apollo.MutationResult<OmniDeletePostMutation>;
export type OmniDeletePostMutationOptions = Apollo.BaseMutationOptions<OmniDeletePostMutation, OmniDeletePostMutationVariables>;
export const OmniMarkMultiplePostsReadyDocument = gql`
    mutation OmniMarkMultiplePostsReady($input: MarkMultiplePostsReadyInput!) {
  markMultiplePostsReady(input: $input) {
    failureCount
    results {
      error
      markedAt
      postId
      success
    }
    successCount
  }
}
    `;
export type OmniMarkMultiplePostsReadyMutationFn = Apollo.MutationFunction<OmniMarkMultiplePostsReadyMutation, OmniMarkMultiplePostsReadyMutationVariables>;

/**
 * __useOmniMarkMultiplePostsReadyMutation__
 *
 * To run a mutation, you first call `useOmniMarkMultiplePostsReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniMarkMultiplePostsReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniMarkMultiplePostsReadyMutation, { data, loading, error }] = useOmniMarkMultiplePostsReadyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniMarkMultiplePostsReadyMutation(baseOptions?: Apollo.MutationHookOptions<OmniMarkMultiplePostsReadyMutation, OmniMarkMultiplePostsReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniMarkMultiplePostsReadyMutation, OmniMarkMultiplePostsReadyMutationVariables>(OmniMarkMultiplePostsReadyDocument, options);
      }
export type OmniMarkMultiplePostsReadyMutationHookResult = ReturnType<typeof useOmniMarkMultiplePostsReadyMutation>;
export type OmniMarkMultiplePostsReadyMutationResult = Apollo.MutationResult<OmniMarkMultiplePostsReadyMutation>;
export type OmniMarkMultiplePostsReadyMutationOptions = Apollo.BaseMutationOptions<OmniMarkMultiplePostsReadyMutation, OmniMarkMultiplePostsReadyMutationVariables>;
export const OmniRegisterDistributionDocument = gql`
    mutation OmniRegisterDistribution($input: RegisterDistributionInput!) {
  registerDistribution(input: $input) {
    distribution {
      channelId
      createdAt
      createdBy
      id
      postId
      publishedAt
      status
      updatedAt
      url
    }
    message
    success
  }
}
    `;
export type OmniRegisterDistributionMutationFn = Apollo.MutationFunction<OmniRegisterDistributionMutation, OmniRegisterDistributionMutationVariables>;

/**
 * __useOmniRegisterDistributionMutation__
 *
 * To run a mutation, you first call `useOmniRegisterDistributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniRegisterDistributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniRegisterDistributionMutation, { data, loading, error }] = useOmniRegisterDistributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniRegisterDistributionMutation(baseOptions?: Apollo.MutationHookOptions<OmniRegisterDistributionMutation, OmniRegisterDistributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniRegisterDistributionMutation, OmniRegisterDistributionMutationVariables>(OmniRegisterDistributionDocument, options);
      }
export type OmniRegisterDistributionMutationHookResult = ReturnType<typeof useOmniRegisterDistributionMutation>;
export type OmniRegisterDistributionMutationResult = Apollo.MutationResult<OmniRegisterDistributionMutation>;
export type OmniRegisterDistributionMutationOptions = Apollo.BaseMutationOptions<OmniRegisterDistributionMutation, OmniRegisterDistributionMutationVariables>;
export const OmniCreatePlanDocument = gql`
    mutation OmniCreatePlan($input: CreatePlanInput!) {
  createPlan(input: $input) {
    planId
    draftId
    channelId
    status
    createdAt
  }
}
    `;
export type OmniCreatePlanMutationFn = Apollo.MutationFunction<OmniCreatePlanMutation, OmniCreatePlanMutationVariables>;

/**
 * __useOmniCreatePlanMutation__
 *
 * To run a mutation, you first call `useOmniCreatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniCreatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniCreatePlanMutation, { data, loading, error }] = useOmniCreatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniCreatePlanMutation(baseOptions?: Apollo.MutationHookOptions<OmniCreatePlanMutation, OmniCreatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniCreatePlanMutation, OmniCreatePlanMutationVariables>(OmniCreatePlanDocument, options);
      }
export type OmniCreatePlanMutationHookResult = ReturnType<typeof useOmniCreatePlanMutation>;
export type OmniCreatePlanMutationResult = Apollo.MutationResult<OmniCreatePlanMutation>;
export type OmniCreatePlanMutationOptions = Apollo.BaseMutationOptions<OmniCreatePlanMutation, OmniCreatePlanMutationVariables>;
export const OmniRequestPlanRenderingDocument = gql`
    mutation OmniRequestPlanRendering($input: RequestPlanRenderingInput!) {
  requestPlanRendering(input: $input) {
    planId
    executionId
    status
    requestedAt
  }
}
    `;
export type OmniRequestPlanRenderingMutationFn = Apollo.MutationFunction<OmniRequestPlanRenderingMutation, OmniRequestPlanRenderingMutationVariables>;

/**
 * __useOmniRequestPlanRenderingMutation__
 *
 * To run a mutation, you first call `useOmniRequestPlanRenderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniRequestPlanRenderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniRequestPlanRenderingMutation, { data, loading, error }] = useOmniRequestPlanRenderingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniRequestPlanRenderingMutation(baseOptions?: Apollo.MutationHookOptions<OmniRequestPlanRenderingMutation, OmniRequestPlanRenderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniRequestPlanRenderingMutation, OmniRequestPlanRenderingMutationVariables>(OmniRequestPlanRenderingDocument, options);
      }
export type OmniRequestPlanRenderingMutationHookResult = ReturnType<typeof useOmniRequestPlanRenderingMutation>;
export type OmniRequestPlanRenderingMutationResult = Apollo.MutationResult<OmniRequestPlanRenderingMutation>;
export type OmniRequestPlanRenderingMutationOptions = Apollo.BaseMutationOptions<OmniRequestPlanRenderingMutation, OmniRequestPlanRenderingMutationVariables>;
export const OmniChannelsDocument = gql`
    query OmniChannels($input: ListChannelsInput!) {
  channels(input: $input) {
    items {
      id
      name
      type
      active
    }
    page
    total
  }
}
    `;

/**
 * __useOmniChannelsQuery__
 *
 * To run a query within a React component, call `useOmniChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniChannelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniChannelsQuery(baseOptions: Apollo.QueryHookOptions<OmniChannelsQuery, OmniChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniChannelsQuery, OmniChannelsQueryVariables>(OmniChannelsDocument, options);
      }
export function useOmniChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniChannelsQuery, OmniChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniChannelsQuery, OmniChannelsQueryVariables>(OmniChannelsDocument, options);
        }
export type OmniChannelsQueryHookResult = ReturnType<typeof useOmniChannelsQuery>;
export type OmniChannelsLazyQueryHookResult = ReturnType<typeof useOmniChannelsLazyQuery>;
export type OmniChannelsQueryResult = Apollo.QueryResult<OmniChannelsQuery, OmniChannelsQueryVariables>;
export const OmniChannelDocument = gql`
    query OmniChannel($id: String!) {
  channel(id: $id) {
    id
    name
    type
    active
  }
}
    `;

/**
 * __useOmniChannelQuery__
 *
 * To run a query within a React component, call `useOmniChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniChannelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOmniChannelQuery(baseOptions: Apollo.QueryHookOptions<OmniChannelQuery, OmniChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniChannelQuery, OmniChannelQueryVariables>(OmniChannelDocument, options);
      }
export function useOmniChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniChannelQuery, OmniChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniChannelQuery, OmniChannelQueryVariables>(OmniChannelDocument, options);
        }
export type OmniChannelQueryHookResult = ReturnType<typeof useOmniChannelQuery>;
export type OmniChannelLazyQueryHookResult = ReturnType<typeof useOmniChannelLazyQuery>;
export type OmniChannelQueryResult = Apollo.QueryResult<OmniChannelQuery, OmniChannelQueryVariables>;
export const OmniWorkflowTypesDocument = gql`
    query OmniWorkflowTypes {
  workflowTypes {
    items {
      id
      code
      name
      description
      isActive
    }
  }
}
    `;

/**
 * __useOmniWorkflowTypesQuery__
 *
 * To run a query within a React component, call `useOmniWorkflowTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniWorkflowTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniWorkflowTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOmniWorkflowTypesQuery(baseOptions?: Apollo.QueryHookOptions<OmniWorkflowTypesQuery, OmniWorkflowTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniWorkflowTypesQuery, OmniWorkflowTypesQueryVariables>(OmniWorkflowTypesDocument, options);
      }
export function useOmniWorkflowTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniWorkflowTypesQuery, OmniWorkflowTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniWorkflowTypesQuery, OmniWorkflowTypesQueryVariables>(OmniWorkflowTypesDocument, options);
        }
export type OmniWorkflowTypesQueryHookResult = ReturnType<typeof useOmniWorkflowTypesQuery>;
export type OmniWorkflowTypesLazyQueryHookResult = ReturnType<typeof useOmniWorkflowTypesLazyQuery>;
export type OmniWorkflowTypesQueryResult = Apollo.QueryResult<OmniWorkflowTypesQuery, OmniWorkflowTypesQueryVariables>;
export const OmniDistributionsDocument = gql`
    query OmniDistributions($filters: DistributionFilters!) {
  distributions(filters: $filters) {
    items {
      id
      postId
      channelId
      url
      status
      publishedAt
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    total
    page
    pageSize
  }
}
    `;

/**
 * __useOmniDistributionsQuery__
 *
 * To run a query within a React component, call `useOmniDistributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniDistributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniDistributionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOmniDistributionsQuery(baseOptions: Apollo.QueryHookOptions<OmniDistributionsQuery, OmniDistributionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniDistributionsQuery, OmniDistributionsQueryVariables>(OmniDistributionsDocument, options);
      }
export function useOmniDistributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniDistributionsQuery, OmniDistributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniDistributionsQuery, OmniDistributionsQueryVariables>(OmniDistributionsDocument, options);
        }
export type OmniDistributionsQueryHookResult = ReturnType<typeof useOmniDistributionsQuery>;
export type OmniDistributionsLazyQueryHookResult = ReturnType<typeof useOmniDistributionsLazyQuery>;
export type OmniDistributionsQueryResult = Apollo.QueryResult<OmniDistributionsQuery, OmniDistributionsQueryVariables>;
export const OmniUpdateDistributionUrlDocument = gql`
    mutation OmniUpdateDistributionUrl($distributionId: String!, $input: UpdateDistributionUrlInput!) {
  updateDistributionUrl(distributionId: $distributionId, input: $input) {
    channelId
    createdAt
    createdBy
    id
    postId
    publishedAt
    status
    updatedAt
    url
  }
}
    `;
export type OmniUpdateDistributionUrlMutationFn = Apollo.MutationFunction<OmniUpdateDistributionUrlMutation, OmniUpdateDistributionUrlMutationVariables>;

/**
 * __useOmniUpdateDistributionUrlMutation__
 *
 * To run a mutation, you first call `useOmniUpdateDistributionUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniUpdateDistributionUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniUpdateDistributionUrlMutation, { data, loading, error }] = useOmniUpdateDistributionUrlMutation({
 *   variables: {
 *      distributionId: // value for 'distributionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniUpdateDistributionUrlMutation(baseOptions?: Apollo.MutationHookOptions<OmniUpdateDistributionUrlMutation, OmniUpdateDistributionUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniUpdateDistributionUrlMutation, OmniUpdateDistributionUrlMutationVariables>(OmniUpdateDistributionUrlDocument, options);
      }
export type OmniUpdateDistributionUrlMutationHookResult = ReturnType<typeof useOmniUpdateDistributionUrlMutation>;
export type OmniUpdateDistributionUrlMutationResult = Apollo.MutationResult<OmniUpdateDistributionUrlMutation>;
export type OmniUpdateDistributionUrlMutationOptions = Apollo.BaseMutationOptions<OmniUpdateDistributionUrlMutation, OmniUpdateDistributionUrlMutationVariables>;
export const OmniGeneratePostPhotoUploadUrlDocument = gql`
    mutation OmniGeneratePostPhotoUploadUrl($fileName: String!, $mimeType: String!, $postId: String!) {
  generatePostPhotoUploadUrl(
    fileName: $fileName
    mimeType: $mimeType
    postId: $postId
  ) {
    expiresAt
    uploadSessionId
    uploadUrl
  }
}
    `;
export type OmniGeneratePostPhotoUploadUrlMutationFn = Apollo.MutationFunction<OmniGeneratePostPhotoUploadUrlMutation, OmniGeneratePostPhotoUploadUrlMutationVariables>;

/**
 * __useOmniGeneratePostPhotoUploadUrlMutation__
 *
 * To run a mutation, you first call `useOmniGeneratePostPhotoUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniGeneratePostPhotoUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniGeneratePostPhotoUploadUrlMutation, { data, loading, error }] = useOmniGeneratePostPhotoUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      mimeType: // value for 'mimeType'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useOmniGeneratePostPhotoUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<OmniGeneratePostPhotoUploadUrlMutation, OmniGeneratePostPhotoUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniGeneratePostPhotoUploadUrlMutation, OmniGeneratePostPhotoUploadUrlMutationVariables>(OmniGeneratePostPhotoUploadUrlDocument, options);
      }
export type OmniGeneratePostPhotoUploadUrlMutationHookResult = ReturnType<typeof useOmniGeneratePostPhotoUploadUrlMutation>;
export type OmniGeneratePostPhotoUploadUrlMutationResult = Apollo.MutationResult<OmniGeneratePostPhotoUploadUrlMutation>;
export type OmniGeneratePostPhotoUploadUrlMutationOptions = Apollo.BaseMutationOptions<OmniGeneratePostPhotoUploadUrlMutation, OmniGeneratePostPhotoUploadUrlMutationVariables>;
export const OmniConfirmPostPhotoUploadDocument = gql`
    mutation OmniConfirmPostPhotoUpload($postId: String!, $uploadSessionId: String!) {
  confirmPostPhotoUpload(postId: $postId, uploadSessionId: $uploadSessionId) {
    altText
    bucketName
    caption
    createdAt
    displayOrder
    id
    mimeType
    objectName
    postId
    size
    storageFileId
    updatedAt
  }
}
    `;
export type OmniConfirmPostPhotoUploadMutationFn = Apollo.MutationFunction<OmniConfirmPostPhotoUploadMutation, OmniConfirmPostPhotoUploadMutationVariables>;

/**
 * __useOmniConfirmPostPhotoUploadMutation__
 *
 * To run a mutation, you first call `useOmniConfirmPostPhotoUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniConfirmPostPhotoUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniConfirmPostPhotoUploadMutation, { data, loading, error }] = useOmniConfirmPostPhotoUploadMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      uploadSessionId: // value for 'uploadSessionId'
 *   },
 * });
 */
export function useOmniConfirmPostPhotoUploadMutation(baseOptions?: Apollo.MutationHookOptions<OmniConfirmPostPhotoUploadMutation, OmniConfirmPostPhotoUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniConfirmPostPhotoUploadMutation, OmniConfirmPostPhotoUploadMutationVariables>(OmniConfirmPostPhotoUploadDocument, options);
      }
export type OmniConfirmPostPhotoUploadMutationHookResult = ReturnType<typeof useOmniConfirmPostPhotoUploadMutation>;
export type OmniConfirmPostPhotoUploadMutationResult = Apollo.MutationResult<OmniConfirmPostPhotoUploadMutation>;
export type OmniConfirmPostPhotoUploadMutationOptions = Apollo.BaseMutationOptions<OmniConfirmPostPhotoUploadMutation, OmniConfirmPostPhotoUploadMutationVariables>;
export const OmniDeletePostPhotoDocument = gql`
    mutation OmniDeletePostPhoto($photoId: String!, $postId: String!) {
  deletePostPhoto(photoId: $photoId, postId: $postId)
}
    `;
export type OmniDeletePostPhotoMutationFn = Apollo.MutationFunction<OmniDeletePostPhotoMutation, OmniDeletePostPhotoMutationVariables>;

/**
 * __useOmniDeletePostPhotoMutation__
 *
 * To run a mutation, you first call `useOmniDeletePostPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniDeletePostPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniDeletePostPhotoMutation, { data, loading, error }] = useOmniDeletePostPhotoMutation({
 *   variables: {
 *      photoId: // value for 'photoId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useOmniDeletePostPhotoMutation(baseOptions?: Apollo.MutationHookOptions<OmniDeletePostPhotoMutation, OmniDeletePostPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniDeletePostPhotoMutation, OmniDeletePostPhotoMutationVariables>(OmniDeletePostPhotoDocument, options);
      }
export type OmniDeletePostPhotoMutationHookResult = ReturnType<typeof useOmniDeletePostPhotoMutation>;
export type OmniDeletePostPhotoMutationResult = Apollo.MutationResult<OmniDeletePostPhotoMutation>;
export type OmniDeletePostPhotoMutationOptions = Apollo.BaseMutationOptions<OmniDeletePostPhotoMutation, OmniDeletePostPhotoMutationVariables>;
export const OmniPostPhotosDocument = gql`
    query OmniPostPhotos($postId: String!) {
  postPhotos(postId: $postId) {
    altText
    bucketName
    caption
    createdAt
    displayOrder
    id
    mimeType
    objectName
    postId
    size
    storageFileId
    updatedAt
    signedUrl
    expiresAt
  }
}
    `;

/**
 * __useOmniPostPhotosQuery__
 *
 * To run a query within a React component, call `useOmniPostPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniPostPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniPostPhotosQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useOmniPostPhotosQuery(baseOptions: Apollo.QueryHookOptions<OmniPostPhotosQuery, OmniPostPhotosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniPostPhotosQuery, OmniPostPhotosQueryVariables>(OmniPostPhotosDocument, options);
      }
export function useOmniPostPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniPostPhotosQuery, OmniPostPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniPostPhotosQuery, OmniPostPhotosQueryVariables>(OmniPostPhotosDocument, options);
        }
export type OmniPostPhotosQueryHookResult = ReturnType<typeof useOmniPostPhotosQuery>;
export type OmniPostPhotosLazyQueryHookResult = ReturnType<typeof useOmniPostPhotosLazyQuery>;
export type OmniPostPhotosQueryResult = Apollo.QueryResult<OmniPostPhotosQuery, OmniPostPhotosQueryVariables>;
export const OmniCreateSnapshotDocument = gql`
    mutation OmniCreateSnapshot($input: CreateSnapshotInput!) {
  createSnapshot(input: $input) {
    id
    distributionId
    metric
    value
    capturedAt
    source
    note
    voided
    createdBy
    createdAt
    updatedAt
  }
}
    `;
export type OmniCreateSnapshotMutationFn = Apollo.MutationFunction<OmniCreateSnapshotMutation, OmniCreateSnapshotMutationVariables>;

/**
 * __useOmniCreateSnapshotMutation__
 *
 * To run a mutation, you first call `useOmniCreateSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmniCreateSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omniCreateSnapshotMutation, { data, loading, error }] = useOmniCreateSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniCreateSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<OmniCreateSnapshotMutation, OmniCreateSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmniCreateSnapshotMutation, OmniCreateSnapshotMutationVariables>(OmniCreateSnapshotDocument, options);
      }
export type OmniCreateSnapshotMutationHookResult = ReturnType<typeof useOmniCreateSnapshotMutation>;
export type OmniCreateSnapshotMutationResult = Apollo.MutationResult<OmniCreateSnapshotMutation>;
export type OmniCreateSnapshotMutationOptions = Apollo.BaseMutationOptions<OmniCreateSnapshotMutation, OmniCreateSnapshotMutationVariables>;
export const OmniListSnapshotHistoryDocument = gql`
    query OmniListSnapshotHistory($input: ListHistoryInput!) {
  listSnapshotHistory(input: $input) {
    items {
      capturedAt
      id
      note
      source
      value
      voided
    }
    page
    pageSize
    total
  }
}
    `;

/**
 * __useOmniListSnapshotHistoryQuery__
 *
 * To run a query within a React component, call `useOmniListSnapshotHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniListSnapshotHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniListSnapshotHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniListSnapshotHistoryQuery(baseOptions: Apollo.QueryHookOptions<OmniListSnapshotHistoryQuery, OmniListSnapshotHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniListSnapshotHistoryQuery, OmniListSnapshotHistoryQueryVariables>(OmniListSnapshotHistoryDocument, options);
      }
export function useOmniListSnapshotHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniListSnapshotHistoryQuery, OmniListSnapshotHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniListSnapshotHistoryQuery, OmniListSnapshotHistoryQueryVariables>(OmniListSnapshotHistoryDocument, options);
        }
export type OmniListSnapshotHistoryQueryHookResult = ReturnType<typeof useOmniListSnapshotHistoryQuery>;
export type OmniListSnapshotHistoryLazyQueryHookResult = ReturnType<typeof useOmniListSnapshotHistoryLazyQuery>;
export type OmniListSnapshotHistoryQueryResult = Apollo.QueryResult<OmniListSnapshotHistoryQuery, OmniListSnapshotHistoryQueryVariables>;